export default __webpack_public_path__ + "static/media/information--built-up-area--g1.ac4f16b0.png";